export const generated_word_count = 100